export default [
    {
        name: 'home-buy-sell.index',
        path: '/home-buy-sell',
        component: () => import('@/views/home-buy-sell/index.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.where-home-buying-journey',
        path: '/home-buy-sell/where-home-buying-journey',
        component: () => import('@/views/home-buy-sell/where-home-buying-journey.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.when-to-buy-home',
        path: '/home-buy-sell/when-to-buy-home',
        component: () => import('@/views/home-buy-sell/when-to-buy-home.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.get-prequalified',
        path: '/home-buy-sell/get-prequalified',
        component: () => import('@/views/home-buy-sell/get-prequalified.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.making-offers-get-prequalified',
        path: '/home-buy-sell/making-offers-get-prequalified',
        component: () => import('@/views/home-buy-sell/get-prequalified.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.signed-agreement-get-prequalified',
        path: '/home-buy-sell/signed-agreement-get-prequalified',
        component: () => import('@/views/home-buy-sell/get-prequalified.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.connected-with-ae',
        path: '/home-buy-sell/connected-with-ae',
        component: () => import('@/views/home-buy-sell/connected-with-ae.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.who-is-ae',
        path: '/home-buy-sell/who-is-ae',
        component: () => import('@/views/home-buy-sell/who-is-ae.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.found-home',
        path: '/home-buy-sell/found-home',
        component: () => import('@/views/home-buy-sell/found-home.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.home-location',
        path: '/home-buy-sell/home-location',
        component: () => import('@/views/home-buy-sell/home-location.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.starting-price',
        path: '/home-buy-sell/starting-price',
        component: () => import('@/views/home-buy-sell/starting-price.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.where-to-buy-first-time-homebuyer',
        path: '/home-buy-sell/where-to-buy-first-time-homebuyer',
        component: () => import('@/views/home-buy-sell/where-to-buy-first-time-homebuyer.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.working-with-buy-agent',
        path: '/home-buy-sell/working-with-buy-agent',
        component: () => import('@/views/home-buy-sell/working-with-buy-agent.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.working-with-sell-agent',
        path: '/home-buy-sell/working-with-sell-agent',
        component: () => import('@/views/home-buy-sell/working-with-sell-agent.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.working-with-real-estate-agent',
        path: '/home-buy-sell/working-with-real-estate-agent',
        component: () => import('@/views/home-buy-sell/working-with-real-estate-agent.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.agent-contact-info',
        path: '/home-buy-sell/agent-contact-info',
        component: () => import('@/views/home-buy-sell/agent-contact-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.buy-agent-contact-info',
        path: '/home-buy-sell/buy-agent-contact-info',
        component: () => import('@/views/home-buy-sell/buy-agent-contact-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.sell-agent-contact-info',
        path: '/home-buy-sell/sell-agent-contact-info',
        component: () => import('@/views/home-buy-sell/sell-agent-contact-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.buying-with-guidance',
        path: '/home-buy-sell/buying-with-guidance',
        component: () => import('@/views/home-buy-sell/buying-with-guidance.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.what-type-home-is',
        path: '/home-buy-sell/what-type-home-is',
        component: () => import('@/views/home-buy-sell/what-type-home-is.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.how-plan-to-use-it',
        path: '/home-buy-sell/how-plan-to-use-it',
        component: () => import('@/views/home-buy-sell/how-plan-to-use-it.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.picked-home-price',
        path: '/home-buy-sell/picked-home-price',
        component: () => import('@/views/home-buy-sell/picked-home-price.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.property-taxes',
        path: '/home-buy-sell/property-taxes',
        component: () => import('@/views/home-buy-sell/property-taxes.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.seller-concessions',
        path: '/home-buy-sell/seller-concessions',
        component: () => import('@/views/home-buy-sell/seller-concessions.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.earnest-money-deposit',
        path: '/home-buy-sell/earnest-money-deposit',
        component: () => import('@/views/home-buy-sell/earnest-money-deposit.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.expected-closing-date',
        path: '/home-buy-sell/expected-closing-date',
        component: () => import('@/views/home-buy-sell/expected-closing-date.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.first-time-homebuyer',
        path: '/home-buy-sell/first-time-homebuyer',
        component: () => import('@/views/home-buy-sell/first-time-homebuyer.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.estimated-down-payment',
        path: '/home-buy-sell/estimated-down-payment',
        component: () => import('@/views/home-buy-sell/estimated-down-payment.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.down-payment-assistance',
        path: '/home-buy-sell/down-payment-assistance',
        component: () => import('@/views/home-buy-sell/down-payment-assistance.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.your-current-address',
        path: '/home-buy-sell/your-current-address',
        component: () => import('@/views/home-buy-sell/your-current-address.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.plan-to-sell',
        path: '/home-buy-sell/plan-to-sell',
        component: () => import('@/views/home-buy-sell/plan-to-sell.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.estimated-selling-price',
        path: '/home-buy-sell/estimated-selling-price',
        component: () => import('@/views/home-buy-sell/estimated-selling-price.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.personal-info',
        path: '/home-buy-sell/personal-info',
        component: () => import('@/views/home-buy-sell/personal-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.your-info',
        path: '/home-buy-sell/your-info',
        component: () => import('@/views/home-buy-sell/your-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.monthly-mortgage-payment',
        path: '/home-buy-sell/monthly-mortgage-payment',
        component: () => import('@/views/home-buy-sell/monthly-mortgage-payment.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.selling-with-guidance',
        path: '/home-buy-sell/selling-with-guidance',
        component: () => import('@/views/home-buy-sell/selling-with-guidance.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.current-mortgage-balance',
        path: '/home-buy-sell/current-mortgage-balance',
        component: () => import('@/views/home-buy-sell/current-mortgage-balance.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.co-applicant',
        path: '/home-buy-sell/co-applicant',
        component: () => import('@/views/home-buy-sell/co-applicant.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.coapplicant-info',
        path: '/home-buy-sell/coapplicant-info',
        component: () => import('@/views/home-buy-sell/coapplicant-contact-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.your-credit-score',
        path: '/home-buy-sell/your-credit-score',
        component: () => import('@/views/home-buy-sell/your-credit-score.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.coapplicant',
        path: '/home-buy-sell/coapplicant',
        component: () => import('@/views/home-buy-sell/coapplicant.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.coapplicant-contact-info',
        path: '/home-buy-sell/coapplicant-contact-info',
        component: () => import('@/views/home-buy-sell/coapplicant-contact-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.employment-status',
        path: '/home-buy-sell/employment-status',
        component: () => import('@/views/home-buy-sell/employment-status.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.bankruptcy',
        path: '/home-buy-sell/bankruptcy',
        component: () => import('@/views/home-buy-sell/bankruptcy.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.finances',
        path: '/home-buy-sell/finances',
        component: () => import('@/views/home-buy-sell/finances.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.create-account',
        path: '/home-buy-sell/create-account',
        component: () => import('@/views/auth/create-account.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.new-account',
        path: '/home-buy-sell/new-account',
        component: () => import('@/views/auth/new-account.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.yearly-income',
        path: '/home-buy-sell/yearly-income',
        component: () => import('@/views/home-buy-sell/yearly-income.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.coapplicant-annual-income',
        path: '/home-buy-sell/coapplicant-annual-income',
        component: () => import('@/views/home-buy-sell/coapplicant-annual-income.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.list-your-expenses',
        path: '/home-buy-sell/list-your-expenses',
        component: () => import('@/views/home-buy-sell/list-your-expenses.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.success',
        path: '/home-buy-sell/success',
        component: () => import('@/views/home-buy-sell/success.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-buy-sell.need-more-info',
        path: '/home-buy-sell/need-more-info',
        component: () => import('@/views/home-buy-sell/need-more-info.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    }
];
